// API provider
// Puts axios on context with custom configuration and error handlers.
// See https://github.com/mzabriskie/axios for full documentation of methods and config.
// Can be added to components using API wrapper component, similar to Redux's connect().
// TODO: Add ability to override default configuration.

import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import PropTypes from 'prop-types'
// import { connectionError, invalidateSession, serverError } from '../actions'

@connect((state) => {
  return {
    isLoggedIn: state.app.isLoggedIn,
    userId: state.userData.userId,
  }
})
export default class ApiProvider extends React.Component {
  static propTypes = {
    baseUrl: PropTypes.string.isRequired,
    headers: PropTypes.object,
  }

  static defaultProps = {
    headers: {
      'Content-Type': 'application/json',
    },
  }

  static childContextTypes = {
    apiInstance: PropTypes.func.isRequired,
  }

  getChildContext() {
    const {baseUrl, headers} = this.props
    const timeout = 60000
    const apiInstance = axios.create({
      baseURL: baseUrl, // Note different casing
      headers,
      timeout,
      //withCredentials: false, // Always send session cookies (JSESSIONID, *_BSA)
    })
    let startTime = 0 // Used to track response time for each request.

    apiInstance.interceptors.request.use(
      (config) => {
        if (this.props.isLoggedIn) {
          config.headers.authorization = 'Bearer ' + this.props.userId
        }
        startTime = Date.now() // Reset start time when request is made.
        return config
      },
      (error) => Promise.reject(error),
    )

    apiInstance.interceptors.response.use(
      (response) => {
        this.trackResponseTiming(startTime, timeout, response.config.url)
        return response.data // Return data off response object instead of whole response
      },
      (error) => this.handleErrors(error), // Use custom error handling
    )

    return {apiInstance}
  }

  render() {
    return React.Children.only(this.props.children)
  }

  handleErrors = (error) => {
    // const { dispatch } = this.props

    if (!error.response) {
      // dispatch(connectionError())
    } else {
      const {response} = error

      console.log(
        `[API_ERROR] Code: ${response.status} - ${response.statusText}`,
      )

      // if (response.status === 403) {
      //   dispatch(invalidateSession())
      // } else if (response.status >= 500) {
      //   dispatch(serverError())
      // } else {
      //   return response.data
      // }
      return response.data
    }
  }

  trackResponseTiming = (startTime, timeout, url) => {
    const time = Date.now() - startTime

    console.log(
      `[TRACKER] Track timing: API Response to ${url} with time ${time}`,
    )
  }
}



// WEBPACK FOOTER //
// ./src/apiProvider.js